import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

// =============================================================================
// useMetaDepartments / useMetaLocations
//
// Read-through caches for the admin-managed lookup tables, used by the
// Invite dialog and the trip-request form. We cache aggressively (10 min)
// because these change rarely; admin edits invalidate them through
// queryClient.invalidateQueries(["meta", ...]).
// =============================================================================

const STALE_MS = 10 * 60 * 1000;

export function useMetaDepartments() {
  return useQuery({
    queryKey: ["meta", "departments"],
    queryFn: ({ signal }) => api.meta.departments(signal),
    staleTime: STALE_MS,
  });
}

export function useMetaLocations() {
  return useQuery({
    queryKey: ["meta", "locations"],
    queryFn: ({ signal }) => api.meta.locations(signal),
    staleTime: STALE_MS,
  });
}
